import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiAddQuestionChangeStrategy } from '../../../../bases';
import { AnswerItem } from '../components';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { MathEnabledTextComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledMatchingAnswersContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding8'));
var StyledSubQuestionDescription = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 400;\n  color: #475569;\n  line-height: 1.5;\n  p {\n    margin: 0;\n    display: inline;\n  }\n"])), getSize('typo14'));

function getAnswerText(q, subQuestionId) {
  var _find, _find2;

  var answerId = (_find = (q.correctAnswers || []).find(function (ca) {
    return ca.subQuestionId === subQuestionId;
  })) === null || _find === void 0 ? void 0 : _find.answerId;
  if (!answerId) return undefined;
  return (_find2 = (q.answers || []).find(function (a) {
    return a.id.toString() === answerId;
  })) === null || _find2 === void 0 ? void 0 : _find2.description;
}

export var MatchingAddQuestionStrategy = /*#__PURE__*/function (_AiAddQuestionChangeS) {
  _inherits(MatchingAddQuestionStrategy, _AiAddQuestionChangeS);

  var _super = _createSuper(MatchingAddQuestionStrategy);

  function MatchingAddQuestionStrategy(context) {
    _classCallCheck(this, MatchingAddQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(MatchingAddQuestionStrategy, [{
    key: "renderSubQuestions",
    value: function renderSubQuestions() {
      var _after$subQuestions;

      var after = this.context.after;
      var subQuestions = (_after$subQuestions = after === null || after === void 0 ? void 0 : after.subQuestions) !== null && _after$subQuestions !== void 0 ? _after$subQuestions : [];
      if (subQuestions.length === 0) return null;
      return /*#__PURE__*/_jsx(StyledMatchingAnswersContainer, {
        children: subQuestions.map(function (sub, idx) {
          var _sub$description;

          var answerText = getAnswerText(after, sub.id.toString());
          return /*#__PURE__*/_jsx(AnswerItem, {
            index: ((after === null || after === void 0 ? void 0 : after.index) || 1) + idx,
            values: {
              description: /*#__PURE__*/_jsx(StyledSubQuestionDescription, {
                value: (_sub$description = sub.description) !== null && _sub$description !== void 0 ? _sub$description : ''
              }),
              isSelected: !!answerText,
              answerPill: answerText !== null && answerText !== void 0 ? answerText : undefined
            }
          }, sub.id.toString());
        })
      });
    }
  }]);

  return MatchingAddQuestionStrategy;
}(AiAddQuestionChangeStrategy);